import { Controller } from "@hotwired/stimulus"
import { chime } from "../lair/chime.js"

// Aemvyra's lines on the first walk (shared/_tour): typed out one at a time,
// a tap to hurry a line or move to the next, and the way on shown once she
// has said her piece.
export default class extends Controller {
  static targets = ["line", "actions", "more"]
  static values = { lines: Array }

  connect() {
    this.index = 0
    this.reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
    if (this.linesValue.length === 0) return

    this.actionsTarget.hidden = true
    this.lineTarget.textContent = ""
    this.start = setTimeout(() => this.say(0), this.reducedMotion ? 0 : 450)
  }

  disconnect() {
    clearTimeout(this.start)
    clearInterval(this.ticker)
  }

  advance() {
    if (this.ticker) return this.finishLine()
    if (this.index < this.linesValue.length - 1) this.say(this.index + 1)
  }

  hide() {
    this.element.hidden = true
  }

  say(index) {
    this.index = index
    const text = this.linesValue[index]
    this.moreTarget.hidden = true
    chime("bubble")

    if (this.reducedMotion) {
      this.lineTarget.textContent = text
      return this.lineDone()
    }

    let shown = 0
    this.lineTarget.textContent = ""
    this.ticker = setInterval(() => {
      shown += 2
      this.lineTarget.textContent = text.slice(0, shown)
      if (shown >= text.length) this.finishLine()
    }, 28)
  }

  finishLine() {
    clearInterval(this.ticker)
    this.ticker = null
    this.lineTarget.textContent = this.linesValue[this.index]
    this.lineDone()
  }

  lineDone() {
    const last = this.index >= this.linesValue.length - 1
    this.moreTarget.hidden = last
    this.actionsTarget.hidden = !last
  }
}
